import { AflaModuleStrategyService } from "./afla-module-strategy.service";
import { ModuleConfigService } from "../module-config/module-config.service";
import { TpamsStrategyService } from "./tpams-strategy.service";
import { BpamsStrategyService } from "./bpams-strategy.service";
import { CemeteryStrategyService } from "./cemetery-strategy.service";
import { WamsStrategyService } from "./wams-strategy-service";
import { PlamsStrategyService } from "./plams-strategy.service";
import { DamsStrategyService } from "./dams-strategy.service";
import { TmamsStrategyService } from "./tmams-strategy.service";
import { EcStrategyService } from "./ec-strategy.service";
import { ItamsStrategyService } from "./itams-strategy.service";
import { RcStrategyService } from "./rc-strategy.service";
import { ZcamsStrategyService } from "./zcams-strategy.service";
import { SnStrategyService } from "./sn-strategy.service";
import { AStrategyService } from "./a-strategy.service";
import { BlStrategyService } from "./bl-strategy.service";
import { GtiaStrategyService } from "./gtia-strategy.service";
import { BpiStrategyService } from "./bpi-strategy.service";
export const aflaModuleStrategyServiceFactory = (moduleConfigService, tpamsStrategyService, bpamsStrategyService, cemeteryStrategyService, plamsStrategyService, wamsStrategyService, damsStrategyService, tmamsStrategyService, ecStrategyService, itamsStrategyService, rcStrategyService, zcamsStrategyService, snStrategyService, aStrategyService, blStrategyService, gtiaStrategyService, bpiStrategyService) => {
    const currentSelectedModuleConfigName = moduleConfigService.getCurrentlySelectedModuleConfigName();
    switch (currentSelectedModuleConfigName) {
        case tpamsStrategyService.name: {
            return tpamsStrategyService;
        }
        case bpamsStrategyService.name: {
            return bpamsStrategyService;
        }
        case bpiStrategyService.name: {
            return bpiStrategyService;
        }
        case cemeteryStrategyService.name: {
            return cemeteryStrategyService;
        }
        case plamsStrategyService.name: {
            return plamsStrategyService;
        }
        case wamsStrategyService.name: {
            return wamsStrategyService;
        }
        case damsStrategyService.name: {
            return damsStrategyService;
        }
        case tmamsStrategyService.name: {
            return tmamsStrategyService;
        }
        case ecStrategyService.name: {
            return ecStrategyService;
        }
        case itamsStrategyService.name: {
            return itamsStrategyService;
        }
        case rcStrategyService.name: {
            return rcStrategyService;
        }
        case zcamsStrategyService.name: {
            return zcamsStrategyService;
        }
        case snStrategyService.name: {
            return snStrategyService;
        }
        case aStrategyService.name: {
            return aStrategyService;
        }
        case blStrategyService.name: {
            return blStrategyService;
        }
        case gtiaStrategyService.name: {
            return gtiaStrategyService;
        }
        default: {
            return null;
        }
    }
};
export let aflaModuleServiceProvider = {
    provide: AflaModuleStrategyService,
    useFactory: aflaModuleStrategyServiceFactory,
    deps: [
        ModuleConfigService,
        TpamsStrategyService,
        BpamsStrategyService,
        CemeteryStrategyService,
        PlamsStrategyService,
        WamsStrategyService,
        DamsStrategyService,
        TmamsStrategyService,
        EcStrategyService,
        ItamsStrategyService,
        RcStrategyService,
        ZcamsStrategyService,
        SnStrategyService,
        AStrategyService,
        BlStrategyService,
        GtiaStrategyService,
        BpiStrategyService
    ]
};
